// <MantineReactTable {...tableProps} />

import { EventDataColumn, EventTypeColumn, IdColumn } from './columns';
import { useMemo, useState } from 'react';

import { DateTimeColumn } from '../../../common';
import { MantineReactTable } from 'mantine-react-table';
import { getCampaignEvents } from '../../../../http/apiClient';
import { useDebouncedCallback } from '@mantine/hooks';
import { usePaginatedQuery } from '../../../../http/queries/usePaginatedQuery';

const CampaignEventsTable = ({ campaign }) => {
    const [globalFilter, setGlobalFilter] = useState(null);
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 20,
    });

    const filterDebounce = useDebouncedCallback((query) => {
        setGlobalFilter(query);
    }, 600);

    const {
        isLoading,
        isError,
        error,
        data: paginatedData,
    } = usePaginatedQuery({
        queryFn: (queryParams) =>
            getCampaignEvents({ id: campaign?.id, pagination: queryParams }),
        queryKey: ['campaign_events', campaign?.id],
        refetchInterval: 15_0000,
        globalFilter,
        pagination,
        sorting,
        enabled: campaign != null,
    });

    const { data: campaignEvents, pagination: dataPagination } =
        paginatedData || {};
    const columns = useMemo(
        () => [
            EventTypeColumn(),
            EventDataColumn(),
            DateTimeColumn({
                id: 'at',
                header: 'At',
                accessorFn: (rowData) => rowData.at,
                format: 'L LTS',
            }),
        ],
        [campaignEvents]
    );

    const tableData = useMemo(
        () => (isLoading ? [] : campaignEvents || []),
        [campaignEvents, isLoading]
    );

    const handleFilterChange = (queryStr) => {
        filterDebounce(queryStr);
    };

    const tableProps = {
        columns: columns,
        data: tableData,
        enableRowActions: false,
        enableColumnResizing: false,
        enableColumnActions: false,
        enableSorting: false,
        enableTopToolbar: false,
        enableGlobalFilter: true,
        enableFilters: false,
        enableStickyHeader: true,
        enableDensityToggle: false,
        positionActionsColumn: 'last',
        layoutMode: 'semantic',
        mantineSearchTextInputProps: {
            placeholder: 'Search Events',
            miw: 200,
        },
        mantineTableContainerProps: {
            style: {
                minHeight: 400,
            },
        },
        positionGlobalFilter: 'left',

        manualPagination: true,
        manualSorting: true,
        //onColumnVisibilityChange: handleVisibilityChange,
        //onColumnSizingChange: handlSizeChange,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        onGlobalFilterChange: handleFilterChange,
        rowCount: dataPagination?.totalItems || 0,
        pageCount: dataPagination?.totalPages || 1,

        initialState: {
            pagination,
            isLoading,
            showGlobalFilter: true,
        },
        state: {
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isLoading,
            sorting,
            density: 'xs',
        },
    };

    return <MantineReactTable {...tableProps} />;
};
export default CampaignEventsTable;
